/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Segment_Start_AriaInputs */



/**
* | output |
* | --- |
* | "Segment start point" |
*
* @param {Video_Export_Segment_Start_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_segment_start_aria = /** @type {((inputs?: Video_Export_Segment_Start_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Segment_Start_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Point de départ du segment")
	if (locale === "de") return /** @type {LocalizedString} */ ("Segmentstartpunkt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Punto di partenza del segmento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Начальная точка сегмента")
	if (locale === "es") return /** @type {LocalizedString} */ ("Punto de inicio del segmento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("线段起点")
	if (locale === "ja") return /** @type {LocalizedString} */ ("セグメント開始点")
	if (locale === "hi") return /** @type {LocalizedString} */ ("खंड का आरंभिक बिंदु")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ponto inicial do segmento")
	return /** @type {LocalizedString} */ ("Segment start point")
});